var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "virtual-tray-search col-12" }, [
    _c("div", { staticClass: "input-group border border-light mb-3" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchtext,
            expression: "searchtext"
          }
        ],
        staticClass: "form-control border-0",
        attrs: {
          type: "search",
          placeholder:
            _vm.$resourceString["account.MyProject.SearchField.Placeholder"]
        },
        domProps: { value: _vm.searchtext },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchtext = $event.target.value
            },
            _vm.updateSearchQuery
          ],
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.submitSearch($event)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-prepend" }, [
        _c(
          "button",
          {
            staticClass: "btn px-1",
            attrs: { tabindex: "-1", type: "submit" },
            on: { click: _vm.submitSearch }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--k-search"
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }